module.exports = __webpack_public_path__ + "static/media/reply.397b636e.svg";